<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }">

        <div v-show="isNavigationInitialized">
            <div class="mobile-navigation__head">
                <div class="mobile-navigation__close" @click="closeNavigation()">
                    <svg width="33" height="28" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2.78809" width="50.3424" height="3.39746" rx="1.69873" transform="rotate(45 2.78809 0)"
                              fill="#F0C42E"/>
                        <rect y="35.5977" width="50.3424" height="3.39746" rx="1.69873"
                              transform="rotate(-45 0 35.5977)"
                              fill="#F0C42E"/>
                        <rect x="5.78809" width="50.3424" height="3.39746" rx="1.69873" transform="rotate(45 5.78809 0)"
                              fill="#0E0F12"/>
                        <rect x="3" y="35.5977" width="50.3424" height="3.39746" rx="1.69873"
                              transform="rotate(-45 3 35.5977)"
                              fill="#0E0F12"/>
                    </svg>
                </div>

                <div class="mobile-navigation__headline">
                    <span>{{ $translate("AbfallbehaelterXXL::Template.navPrevTitle") }}</span></div>

            </div>
            <ul v-menu id="menu-1" class="mainmenu menu-active">
                <li class="ddown" v-if="dataContainer1.parent"
                    @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                    <span class="nav-direction btn-up">
                       <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.6663 5.71396L2.27567 5.71396L5.85167 2.13796C6.112 1.87762 6.112 1.45546 5.85184 1.19529C5.5915 0.934957 5.16917 0.934957 4.90884 1.19529L0.195003 5.90929C0.164003 5.94029 0.136338 5.97446 0.112004 6.01079C0.100837 6.02763 0.0930028 6.04579 0.0833363 6.06329C0.0723367 6.08396 0.05967 6.10363 0.050837 6.12546C0.0413365 6.14796 0.0360036 6.17129 0.0293374 6.19463C0.0238366 6.21313 0.0166707 6.23079 0.0128369 6.24979C0.00417089 6.29313 -0.000330446 6.33679 -0.000330442 6.38063C-0.000330442 6.38113 -0.000163549 6.38163 -0.000163549 6.38213C3.34821e-06 6.42529 0.00433685 6.46863 0.012837 6.51113C0.0168367 6.53113 0.0243364 6.54963 0.03017 6.56929C0.0366702 6.59146 0.0416703 6.61396 0.0506702 6.63546C0.0603366 6.65863 0.0733371 6.67963 0.0853372 6.70146C0.094337 6.71779 0.101503 6.73446 0.111836 6.75013C0.13617 6.78696 0.164171 6.82129 0.195338 6.85246L4.90901 11.566C5.16934 11.8263 5.59151 11.8263 5.85184 11.5661C6.11217 11.3058 6.11217 10.8836 5.85184 10.6231L2.27584 7.04729L12.6663 7.04729C13.0345 7.04729 13.333 6.74879 13.333 6.38062C13.333 6.01246 13.0345 5.71396 12.6663 5.71396Z"
                                fill="#F0C42E"/>
                            <path
                                d="M12.6663 4.71396L2.27567 4.71396L5.85167 1.13796C6.112 0.877623 6.112 0.455457 5.85184 0.19529C5.5915 -0.0650428 5.16917 -0.0650427 4.90884 0.19529L0.195003 4.90929C0.164003 4.94029 0.136338 4.97446 0.112004 5.01079C0.100837 5.02763 0.0930028 5.04579 0.0833363 5.06329C0.0723367 5.08396 0.05967 5.10363 0.050837 5.12546C0.0413365 5.14796 0.0360036 5.17129 0.0293374 5.19463C0.0238366 5.21313 0.0166707 5.23079 0.0128369 5.24979C0.00417089 5.29313 -0.000330446 5.33679 -0.000330442 5.38063C-0.000330442 5.38113 -0.000163549 5.38163 -0.000163549 5.38213C3.34821e-06 5.42529 0.00433685 5.46863 0.012837 5.51113C0.0168367 5.53113 0.0243364 5.54963 0.03017 5.56929C0.0366702 5.59146 0.0416703 5.61396 0.0506702 5.63546C0.0603366 5.65863 0.0733371 5.67963 0.0853372 5.70146C0.094337 5.71779 0.101503 5.73446 0.111836 5.75013C0.13617 5.78696 0.164171 5.82129 0.195338 5.85246L4.90901 10.566C5.16934 10.8263 5.59151 10.8263 5.85184 10.5661C6.11217 10.3058 6.11217 9.88363 5.85184 9.62313L2.27584 6.04729L12.6663 6.04729C13.0345 6.04729 13.333 5.74879 13.333 5.38062C13.333 5.01246 13.0345 4.71396 12.6663 4.71396Z"
                                fill="#0E0F12"/>
                        </svg>
                        <span v-if="typeof dataContainer1.parent.details !== 'undefined'">{{ dataContainer1.parent.details[0].name }}</span>
                    </span>
                </li>

                <li class="ddown" v-for="category in dataContainer1.categories">
                    <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                        <svg width="9" height="11" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.43617 4.38461L2.44086 7.37992C2.16617 7.65461 1.7168 7.65461 1.44242 7.37992L1.19211 7.12992C0.917734 6.85586 0.917734 6.40617 1.19211 6.1318L3.47805 3.84586L1.19211 1.55961C0.917734 1.28523 0.917734 0.835547 1.19211 0.561485L1.44242 0.311484C1.7168 0.036797 2.16617 0.036797 2.44086 0.311484L5.43617 3.30742C5.58367 3.45461 5.6493 3.65242 5.63836 3.84586C5.6493 4.0393 5.58367 4.2368 5.43617 4.38461Z"
                                fill="#0E0F12"/>
                        </svg>
                    </span>
                </li>
                <template v-if="dataContainer1.categories[0]">
                    <li class="ddown"
                        v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                        <span class="nav-placeholder" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer1.parent">
                    <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                        <span class="nav-placeholder" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
            </ul>

            <ul v-menu id="menu-2" class="mainmenu">
                <li class="ddown" v-if="dataContainer2.parent"
                    @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                    <span class="nav-direction btn-up">
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.6663 5.71396L2.27567 5.71396L5.85167 2.13796C6.112 1.87762 6.112 1.45546 5.85184 1.19529C5.5915 0.934957 5.16917 0.934957 4.90884 1.19529L0.195003 5.90929C0.164003 5.94029 0.136338 5.97446 0.112004 6.01079C0.100837 6.02763 0.0930028 6.04579 0.0833363 6.06329C0.0723367 6.08396 0.05967 6.10363 0.050837 6.12546C0.0413365 6.14796 0.0360036 6.17129 0.0293374 6.19463C0.0238366 6.21313 0.0166707 6.23079 0.0128369 6.24979C0.00417089 6.29313 -0.000330446 6.33679 -0.000330442 6.38063C-0.000330442 6.38113 -0.000163549 6.38163 -0.000163549 6.38213C3.34821e-06 6.42529 0.00433685 6.46863 0.012837 6.51113C0.0168367 6.53113 0.0243364 6.54963 0.03017 6.56929C0.0366702 6.59146 0.0416703 6.61396 0.0506702 6.63546C0.0603366 6.65863 0.0733371 6.67963 0.0853372 6.70146C0.094337 6.71779 0.101503 6.73446 0.111836 6.75013C0.13617 6.78696 0.164171 6.82129 0.195338 6.85246L4.90901 11.566C5.16934 11.8263 5.59151 11.8263 5.85184 11.5661C6.11217 11.3058 6.11217 10.8836 5.85184 10.6231L2.27584 7.04729L12.6663 7.04729C13.0345 7.04729 13.333 6.74879 13.333 6.38062C13.333 6.01246 13.0345 5.71396 12.6663 5.71396Z"
                                fill="#F0C42E"/>
                            <path
                                d="M12.6663 4.71396L2.27567 4.71396L5.85167 1.13796C6.112 0.877623 6.112 0.455457 5.85184 0.19529C5.5915 -0.0650428 5.16917 -0.0650427 4.90884 0.19529L0.195003 4.90929C0.164003 4.94029 0.136338 4.97446 0.112004 5.01079C0.100837 5.02763 0.0930028 5.04579 0.0833363 5.06329C0.0723367 5.08396 0.05967 5.10363 0.050837 5.12546C0.0413365 5.14796 0.0360036 5.17129 0.0293374 5.19463C0.0238366 5.21313 0.0166707 5.23079 0.0128369 5.24979C0.00417089 5.29313 -0.000330446 5.33679 -0.000330442 5.38063C-0.000330442 5.38113 -0.000163549 5.38163 -0.000163549 5.38213C3.34821e-06 5.42529 0.00433685 5.46863 0.012837 5.51113C0.0168367 5.53113 0.0243364 5.54963 0.03017 5.56929C0.0366702 5.59146 0.0416703 5.61396 0.0506702 5.63546C0.0603366 5.65863 0.0733371 5.67963 0.0853372 5.70146C0.094337 5.71779 0.101503 5.73446 0.111836 5.75013C0.13617 5.78696 0.164171 5.82129 0.195338 5.85246L4.90901 10.566C5.16934 10.8263 5.59151 10.8263 5.85184 10.5661C6.11217 10.3058 6.11217 9.88363 5.85184 9.62313L2.27584 6.04729L12.6663 6.04729C13.0345 6.04729 13.333 5.74879 13.333 5.38062C13.333 5.01246 13.0345 4.71396 12.6663 4.71396Z"
                                fill="#0E0F12"/>
                        </svg>
                        <span v-if="typeof dataContainer2.parent.details !== 'undefined'">{{ dataContainer2.parent.details[0].name }}</span>
                    </span>
                </li>

                <li class="ddown" v-for="category in dataContainer2.categories">
                    <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                        <svg width="9" height="11" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.43617 4.38461L2.44086 7.37992C2.16617 7.65461 1.7168 7.65461 1.44242 7.37992L1.19211 7.12992C0.917734 6.85586 0.917734 6.40617 1.19211 6.1318L3.47805 3.84586L1.19211 1.55961C0.917734 1.28523 0.917734 0.835547 1.19211 0.561485L1.44242 0.311484C1.7168 0.036797 2.16617 0.036797 2.44086 0.311484L5.43617 3.30742C5.58367 3.45461 5.6493 3.65242 5.63836 3.84586C5.6493 4.0393 5.58367 4.2368 5.43617 4.38461Z"
                                fill="#0E0F12"/>
                        </svg>
                    </span>
                </li>
                <template v-if="dataContainer2.categories[0]">
                    <li class="ddown"
                        v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                        <span class="nav-placeholder" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer2.parent">
                    <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                        <span class="nav-placeholder" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
            </ul>
        </div>

        <template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>
            <div class="loading">
                <loading-animation></loading-animation>
            </div>
        </template>
    </div>
</template>

<script>
import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean
    },

    data() {
        return {
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null
        };
    },

    computed:
        {
            breadcrumbs() {
                const breadcrumbs = [];
                let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

                while (container && container.parent && Object.keys(container.parent).length) {
                    breadcrumbs.unshift(
                        {
                            name: container.parent.details[0].name,
                            parent: container.parent || null
                        });

                    container = container.parent;
                }

                return breadcrumbs;
            },

            ...mapState({
                navigationTree: state => state.navigation.tree,
                isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
            })
        },

    created() {
        // this.addEventListener();
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },
    mounted() {
        this.addEventListener();
    },

    methods:
        {
            addEventListener() {
                const QueryHelper = new MediaQueryHelper();
                const breakpoint = QueryHelper.getCurrentBreakpoint();

                QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

                if (this.breakpoints.includes(breakpoint)) {
                    this.loadInitialTree();
                }
            },

            loadInitialTree() {
                if (this.navigationTree.length <= 0) {
                    const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

                    this.$store.dispatch("loadPartialNavigationTree", categoryId)
                        .then(response => {
                            this.$store.commit("setNavigationTree", response);
                            this.initNavigation();
                        });
                }
            },

            initNavigation() {
                if (this.initialCategory && this.initialCategory.id) {
                    if (this.initialCategory.linklist === "N") {
                        this.$store.commit("setCurrentCategory", this.initialCategory);
                    } else {
                        this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                        this.initialSlide(this.$store.state.navigation.currentCategory);
                    }
                }

                this.dataContainer1.parent = null;
                this.dataContainer1.categories = this.navigationTree;
                this.isNavigationInitialized = true;
            },

            initialSlide(currentCategory) {
                if (currentCategory) {
                    if (currentCategory.children) {
                        this.slideTo(currentCategory);
                    } else if (currentCategory.parent) {
                        this.slideTo(currentCategory.parent);
                    }
                }
            },

            slideTo(category, back) {
                const children = isDefined(category) ? category.children : this.navigationTree;
                const categoryId = isDefined(category) ? category.id : null;

                this.loadPartialTree(categoryId);
                this.selectedCategory = category;

                if (this.useFirstContainer) {
                    this.dataContainer1.parent = category;
                    this.dataContainer1.categories = children || [];

                    $("#menu-2").trigger("menu-deactivated", { back: !!back });
                    $("#menu-1").trigger("menu-activated", { back: !!back });
                } else {
                    this.dataContainer2.parent = category;
                    this.dataContainer2.categories = children || [];

                    $("#menu-1").trigger("menu-deactivated", { back: !!back });
                    $("#menu-2").trigger("menu-activated", { back: !!back });
                }

                this.useFirstContainer = !this.useFirstContainer;
            },

            loadPartialTree(categoryId) {
                // eslint-disable-next-line eqeqeq
                if (this.selectedCategory != categoryId ||
                    (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId)) {
                    this.$store.dispatch("loadPartialNavigationTree", categoryId)
                        .then(response => {
                            if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                                (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId)) {
                                this.$store.commit("setNavigationTree", response);
                                this.updateDataContainers(categoryId);
                            }
                        });
                }
            },

            updateDataContainers(categoryId) {
                const containers = ["dataContainer1", "dataContainer2"];
                const category = this.getCategoryById(categoryId, this.navigationTree);

                for (const container of containers) {
                    if (category) {
                        this[container].parent = category;
                        this[container].categories = category.children;
                    } else {
                        // root level
                        this[container].parent = null;
                        this[container].categories = this.navigationTree;
                    }
                }
            },

            getCategoryById(categoryId, tree) {
                for (const cat of tree) {
                    if (categoryId === cat.id) {
                        return cat;
                    } else if (cat.children) {
                        const foundCat = this.getCategoryById(categoryId, cat.children);

                        if (foundCat) {
                            return foundCat;
                        }
                    }
                }

                return null;
            },

            closeNavigation() {
                // document.querySelector(".mobile-navigation").classList.remove("open");
                // document.querySelector("body").classList.remove("menu-is-visible");

                this.$store.commit("setIsMobileNavigationOpen", false);
            },

            getCategoryUrl(url) {
                const trailingSlash = url[0] === "/" ? "" : "/";
                const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

                return prefix + url;
            }
        },

    directives:
        {
            menu: {
                bind(el) {
                    // add "activated" classes when menu is activated
                    $(el).on("menu-activated", (event, params) => {
                        $(event.target).addClass("menu-active");
                        $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                    });
                    // add "deactivated" classes when menu is deactivated
                    $(el).on("menu-deactivated", (event, params) => {
                        $(event.target).removeClass("menu-active");
                        $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                    });
                    // this removes the animation class automatically after the animation has completed
                    $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
                        $(".mainmenu").removeClass((index, className) => {
                            return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                        });
                    });
                }
            }
        }
}
</script>
